import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import script from './js/script'
import store from './store/index'

import Vuelidate from "vuelidate";

Vue.use(Vuelidate);

Vue.config.productionTip = false;

//vuesax
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css';

Vue.use(Vuesax);

// axios
import axios from 'axios'
axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

// ueObserveVisibility
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility);

import 'jquery/dist/jquery.min';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'jquery.uniform/dist/js/jquery.uniform.bundled';
import '../node_modules/simplebar/dist/simplebar.min';
import 'svg-injector/dist/svg-injector.min';
import 'jquery-ui-dist/jquery-ui.min';
import 'jquery-ui-dist/jquery-ui.min.css';
import 'bootstrap-select/dist/js/bootstrap-select';
import '../src/assets/css/bootstrap-select.min.css'
import '../node_modules/daterangepicker/daterangepicker';
// import '../src/assets/css/daterangepicker.css';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'


//vue-toastr plugin
import VueToastr from "vue-toastr";
Vue.use(VueToastr, {});

//npm vue-loaders
import VueLoaders from 'vue-loaders';
Vue.use(VueLoaders);

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

// Styles: SCSS
import "./assets/css/sass_changed/style.scss";
import './assets/css/default.css';
import './assets/css/simplebar.css';
import 'vue-loaders/dist/vue-loaders.css';


axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        store.dispatch('updateAccessToken')
            .catch(() => {
                localStorage.removeItem('vuex');
                localStorage.removeItem('accessToken');
                router.push('/login')
            })

    }
    return error;
});


Vue.config.productionTip = false

new Vue({
    router,
    script,
    store,
    render: h => h(App),
}).$mount('#app')
